import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { environment } from '../../../../environments/environment';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { MemberNotificationService } from '../../../shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { TagSelectorComponent } from '../../community/tag-selector/tag-selector.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { YoutubeIframesComponent } from 'src/app/youtube-iframes/youtube-iframes.component';
import { ContributeToProductComponent } from 'src/app/contribute-to-product/contribute-to-product.component';
import { PopUpService } from 'src/app/popupservice.service';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FollowService } from 'src/app/follow.service';
import { CommonProductChangeTagComponent } from './common-product-change-tag/common-product-change-tag.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'common-product-card-view',
  templateUrl: './common-product-card-view.component.html',
  styleUrls: ['./common-product-card-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonProductCardViewComponent
  implements OnInit, AfterViewChecked, OnChanges, OnDestroy {
  @Input() isCommunityProduct: boolean = false;
  @Input() isSearch: boolean = false;
  @Input() list: any = {};
  @Input() ads: boolean = false;
  @Input() d: any = {};
  @Input() withHighlight = false;
  @Input() toSinglePage: boolean = false;
  @Input() canBeSelected: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() postalCode: any = {};
  @Input() isUpvote: boolean = false;
  @Input() filterMapsIcon: any = [];
  @Input() noCrop: boolean = false;
  @Input() showLocationIconNextToRegion = false;
  @Input() viewDesign: string = 'grid';

  public viewCount = 0;

  public infoCount = 0;

  // Controls visibility of the middle-contact section on hover over .additional-tag
  public showMiddleContact = false;

  @Output() view = new EventEmitter<any>(); // Event to view product
  @Output() locationButtonClicked = new EventEmitter();
  @Output() selected = new EventEmitter<boolean>(); //whether  to thhe productis selected or not

  onLocationButtonClicked() {
    this.locationButtonClicked.next(this.list);
  }
  getVerifiedClasses() {
    return {
      popular: this.verifiedTagRating === 1,
      gold: this.verifiedTagRating === 2,
      shining: this.verifiedTagRating === 3,
      'verified-special-red': this.list.verifiedTag?.trim() === 'Top Seller',
      'verified-special': this.list.verifiedTag?.trim() === 'Preferred',
    };
  }

  getVerifiedText(num: number): string {
    switch (num) {
      case 1:
        return 'popular';
      case 2:
        return 'gold';
      case 3:
        return 'shining';
      default:
        return '';
    }
  }
  public selectedChanged() {
    this.selected.emit(this.isSelected);
  }

  public get isBrowser() {
    return this.sharedService.isBrowser();
  }

  public get isSameSubRegion() {
    return (
      this.isLogin && this.list?.subRegionId == this.local.getUser()?.region
    );
  }

  public specialTags = new Set([
    'Preferred',
    'Top Seller',
    'Freelance',
    'Chain',
  ]);

  public get isThereValidCropInformation(): boolean {
    const cropInfo = this.list?.mainImageCropInformation;
    if (!cropInfo || cropInfo == 'null' || cropInfo == 'undefined') {
      return false;
    }
    try {
      const data =
        typeof cropInfo == 'object' ? cropInfo : JSON.parse(cropInfo);
      const { isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio } = data;
      const neededData = [
        isYAxisTheOneThatIsLocked,
        offsetRatio,
        imageAspectRatio,
      ];
      return !neededData.includes(null) && !neededData.includes(undefined);
    } catch (e) {
      return false;
    }
  }

  // public moduloIncreaseDollarSign() {
  //   this.auth.moduloIncreaseDollarSignRating(this.list?.id)
  //     .subscribe({
  //       next: () => {
  //         this.toastr.success("Increased")

  //         this.list.dollarSignRating += 1
  //         this.list.dollarSignRating %= 4

  //       },
  //       error: err => {
  //         console.error(err);
  //         this.toastr.error("Something went wrong")
  //       }
  //     })
  //}
  public get verifiedTagRating() {
    const rawCount = this.list?.verifiedTagRating;
    if (rawCount) {
      if (rawCount >= 100) {
        return 3;
      }
      if (rawCount >= 10) {
        return 2;
      }
    }
    return 1;
  }

  public get googleRating() {
    // Check if ratings array exists and has Google rating
    if (this.list?.ratings && Array.isArray(this.list.ratings)) {
      const googleRating = this.list.ratings.find((r: any) => r.id === 'ggle');
      if (googleRating) {
        return {
          rating: googleRating.rating || 0,
          count: googleRating.counts || 0
        };
      }
    }
    
    // Check seller_info for Google review data
    if (this.list?.seller_info) {
      let sellerInfo = this.list.seller_info;
      if (typeof sellerInfo === 'string') {
        try {
          sellerInfo = JSON.parse(sellerInfo);
        } catch (e) {
          return null;
        }
      }
      
      if (sellerInfo?.googleReviewRating) {
        return {
          rating: sellerInfo.googleReviewRating,
          count: sellerInfo.googleReviewCount || 0
        };
      }
    }
    
    return null;
  }
  public followLikes = '';
  public followRecommendedBy = '';
  public followLikedBy = '';
  public getFollowBasedDataForProduct() {
    this.followService.followedFavorites
      .pipe(takeUntil(this.destroy$))

      .subscribe((data) => {
        data = data.filter((fav) => {
          // console.log(fav.member_product_id , this.list?.id)
          return fav.member_product_id == this.list?.id;
        });
        //console.log({data}, 'dataa')
        if (data.length) {
          this.followLikes =
            `
           Liked By: ` + data.map((u) => u.name).join(',');
        } else {
          this.followLikes = '';
        }
      });

    this.followService.followedRecommendedProducts
      .pipe(takeUntil(this.destroy$))

      .subscribe((data: any) => {
        data = data.find((prod) => prod.id == this.list?.id)?.appUser
          ?.profileCharacterName as string;
        this.followRecommendedBy = data ?? '';
      });
  }

  openSuggestionPopup() {
    const ref = this.modalService.open(TagSelectorComponent, {
      size: 'sm',
      centered: true,
    });
    ref.componentInstance.productId = this.list.id;
    return ref;
  }

  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  public latLong: any = {};

  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private memberNotificationService: MemberNotificationService,
    public roleService: RoleService,
    public commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    @Inject('WINDOW') private window: any,
    private cdr: ChangeDetectorRef,
    private popup: PopUpService,
    private followService: FollowService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.infoCount = this.commonService.getProductInformationScore(this.list);
    // Check Within Radius
    if (this.sharedService.isBrowser() && changes['list']) {
      this.getFollowBasedDataForProduct();
    }

    const postalCode = changes['postalCode'];
    if (postalCode?.currentValue?.lat && postalCode?.currentValue?.lng) {
      // console.log('checking if is withing radius given full location')
      // this.latLong = postalCode;
      const modifiedList = { ...this.list };
      if (modifiedList?.latLong && modifiedList.latLong != '{}') {
        let latLong = modifiedList.latLong;
        if (typeof latLong == 'string') {
          try {
            latLong = JSON.parse(modifiedList.latLong);
          } catch (e) {
            console.error(e);
          }
        }

        const isWithinRadius = this.local.isWithinRadius(
          latLong,
          postalCode?.currentValue,
          5
        );
        //console.log({isWithinRadius})
        modifiedList.isWithinRadius = isWithinRadius.check;
        modifiedList.distance = isWithinRadius.distance;
        this.list = modifiedList;
      }
    } else {
      this.list.isWithinRadius = false;
      this.list.distance = 0;
      //console.log('full location not given')
    }

    if (changes['list']) {
      this._sanitizeYoutubeIframes();
      this.loadMoreBadges();
    }
    this.additionalTag = this.list?.additionalTag?.trim()?.toLowerCase();
  }
  ngAfterViewChecked(): void {
    // this.loadMoreBadges();
    //this.cdr.detectChanges();
  }

  public categoryImage = '';
  public timeout1: any;
  private _refreshProductData() {
    this.auth.getShopProductDetails({ productId: this.list?.id }).subscribe({
      next: (data) => {
        this.list = data.body;
        this.cdr.detectChanges();
        // console.log('product updated');
      },
      error: console.error,
    });
  }
  ngOnInit(): void {

    // if(this.sharedService.isBrowser()){
    //   this.getFollowBasedDataForProduct()
    // }
    //this.loadForums()
    this.sharedService.refreshProductId
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data.action == 'edited' && data.productId == this.list?.id) {
          // console.log({data,}, this.list?.id)
          this._refreshProductData();
        }
      });

    this.local
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user) => {
        if (user?.id) {
          this.isLogin = 1;
          this.latLong = user.latLong;
        } else {
          this.isLogin = 0;
        }
      });

    // Create a shallow copy of the list object to avoid modifying the original input
    const modifiedList = { ...this.list };

    if (!modifiedList.foodImages) {
      modifiedList.foodImages = modifiedList.memberShopProductsImages;
    }

    if (modifiedList.user_detail?.shop_name === 'null') {
      modifiedList.user_detail.shop_name = null;
    }

    if (modifiedList.type == 'rental') {
      modifiedList.name += ' - RENTAL';
    }

    this.list = modifiedList; // Update the list reference

    this.viewCount = this.list.viewCount;
    this.cdr.detectChanges();
  }

  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    if (this.timeout1) {
      clearTimeout(this.timeout1);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  public roleSubscription() {
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        // console.log('roles', roles);
        // this.cdr.detectChanges();
      });
  }

  public otherRatingBadges = [];
  public otherRatingBadgesConfig = {
    slidesPerView: 1,
    autoPlay: true,
    navigation: false,
  };
  private loadMoreBadges() {
    // this.cdr.detectChanges();
    if (this.otherRatingBadges?.length) {
      return;
    }
    this.otherRatingBadges = [];
    if (this.list && 'seller_info' in this.list) {
      try {
        let sellerInfo = this.list['seller_info'];
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(this.list['seller_info']);
        }

        if (sellerInfo) {
          if (
            'superDealRating' in sellerInfo &&
            (sellerInfo.superDealRating || sellerInfo.superDealText)
          ) {
            this.otherRatingBadges.push({
              icon: 'super_deal_1.png',
              name: 'Super Deal',
              rating: sellerInfo.superDealRating,
              text: sellerInfo.superDealText,
            });
          }

          if (
            'bestPriceRating' in sellerInfo &&
            (sellerInfo.bestPriceRating || sellerInfo.bestPriceText)
          ) {
            this.otherRatingBadges.push({
              icon: 'best_price_1.png',
              name: 'Best Price',
              rating: sellerInfo.bestPriceRating,
              text: sellerInfo.bestPriceText,
            });
          }

          if (
            'highQualityRating' in sellerInfo &&
            (sellerInfo.highQualityRating || sellerInfo.highQualityText)
          ) {
            this.otherRatingBadges.push({
              icon: 'high_quality_1.png',
              name: 'Hight Quality',
              rating: sellerInfo.highQualityRating,
              text: sellerInfo.highQualityText,
            });
          }
        }
      } catch (e) {
        console.warn(e);
      }
    }
    this.cdr.detectChanges();
  }

  public regionSplit(name: string): string {
    if (name && name.includes(',')) {
      let data = name.split(',');
      return `${data[0]}, ${data[1].trim().charAt(0)}`;
    } else {
      return name;
    }
  }

  public goToBiz(list: any) {
    this.router.navigate(['/biz/shop', list?.adminId], {
      state: {
        scrollPosition: [this.window.scrollX, this.window.scrollY],
      },
    });
  }
  public get productTag() {
    if (this.list?.hasCrown) {
      return this.getVerifiedText(this.verifiedTagRating);
    }
    if (this.isVerified) {
      return this.list.verifiedTag ? this.list.verifiedTag : 'Verified';
    }
  }

  handleInfoAP() {
    this.local.alertInfo({
      title: `<p style="color: var(--primary)">AP (Ambassador Program)</p>`,
      message: `
      <p style="color: var(--primary)">Business is running a loyalty program to reward referrals and believers in their product & services. This payment is only redeemable via PAYNOW. Please contact support if you have any questions. Participation is not mandatory. T&C applies.</p>
    `,
    });
  }

  public get isVerified(): boolean {
    return (
      this.list?.productVerficationsList?.length ||
      this.list?.verifiedTag ||
      this.list?.hasCrown
    );
  }
  @ViewChild('discussDialog')
  public discussDialog: TemplateRef<any>;
  public openDiscuss(productData) {
    this.loadForums();
    this.modalService.open(this.discussDialog, { size: 'sm' });
  }

  public productForum = null;
  public repliesHolders = [];

  private _fetchForumReplies(forum) {
    //console.log({ forum })
    this.auth
      .marketplace_forum_shop_fetch_reply(forum?.id, 1, true, false, 3)
      // .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          // console.log({ data });
          forum.replies = data.body;
        },
      });
  }

  @ViewChild('addComment')
  public addCommentModal;
  public openAddCommentModal(forum) {
    this.modalService.open(this.addCommentModal, {
      size: 'md',
      centered: true,
    });
  }
  public repliesHolder = '';
  public addPostToForum() {
    if (!this.repliesHolder) {
      return;
    }
    const form = {
      forumId: this.productForum?.id,
      message: this.repliesHolder,
      createdBy: this.local.getUser()?.id,
      // id: id,
      // isChild: isChild,
      // parentChild: parentChild,
    };

    // console.log({ form }, this.repliesHolder)
    try {
      this.auth.marketplace_forum_shop_store_reply(form).subscribe({
        next: () => {
          this.loadForums();
          this.toastr.success('Posted');
          this.modalService.dismissAll();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while posting response');
        },
      });
    } catch (e) {
      console.error(e);
    }
  }
  openContribute() {
    let ref = this.popup.openPopup(ContributeToProductComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      hasBackdrop: true,
      modalSize: 'md',
      noHistory: true,
    });
    if (this.sharedService.isOnMobile) {
      (ref as MatBottomSheetRef).instance.productData = this.list;
    } else {
      ref = ref as NgbModalRef;
      ref.componentInstance.productData = this.list;
    }
  }
  public loadForums() {
    this.auth.marketplace_forum_shop_fetch_by_shopId(this.list?.id).subscribe({
      next: (data: any) => {
        this.productForum = structuredClone(data.body.data[0]);
        //console.log({ data });
        this._fetchForumReplies(this.productForum);
      },
      error: console.error,
    });
  }
  private favProduct(item, value = '') {
    const param =
      !this.window.location.href.includes('/biz') && !item?.user_detail
        ? 'member_product_id'
        : 'foodId';

    const formData = {
      [param]: item.id,
      isAdmin: false,
    };
    formData.openComment = value;
    this.auth
      .marketplace_favorite_product(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.list.foodFavoritesCount = response.body?.length || 0;
        this.list.isFavorite = !this.list.isFavorite;
        if (this.list.isProfile) {
          this.sharedService.triggerProfileService({});
        }
        this.memberNotificationService.getNotification();
      });
  }

  public favoriteProduct(item: any) {
    if (this.isLogin) {
      if (!item.isFavorite) {
        const title = this.isUpvote ? 'Upvote' : 'Favourites';
        const text = this.isUpvote ? 'Add to Upvote ' : 'Add to Favourites ';
        Swal.fire({
          // title: 'Add product to favorites?',
          // text:"What fo you like about this product",
          // icon: 'info',
          html: `
              <div class="custom-modal">
                <i class="fa-solid fa-heart" style="font-size: 4rem; color: var(--secondary);"></i>
                <p class="modal-text">What do you like about this product?</p>
                <textarea id="firstTextarea" class="form-control" placeholder="Write something..." maxlength="50" style="width: 100%; margin: 10px 0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; resize: vertical; min-height: 60px;"></textarea>
                <div class="${this.isAdmin ? 'd-block' : 'd-none'}">
                  <p style="margin: 10px 0 5px 0;">What do you think needs to be improved?</p>
                  <textarea class="form-control" placeholder="Additional comments..." maxlength="50" style="width: 100%; margin: 0 0 10px 0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; resize: vertical; min-height: 60px;"></textarea>
                </div>
              </div>
            `,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: 'var(--primary)',
          preConfirm: () => {
            const firstTextarea = document.getElementById(
              'firstTextarea'
            ) as HTMLTextAreaElement;
            return firstTextarea ? firstTextarea.value : '';
          },
        }).then((c: any) => {
          if (c.isConfirmed) {
            this.favProduct(item, c.value);
          }
        });
      } else {
        this.favProduct(item);
      }
    } else {
      document.getElementById('loginBtn').click();
    }
  }
  public get isMemberProduct() {
    return 'appUser' in this.list;
  }
  // isAdmin = () => this.roleService?.roles?.userType.includes('ADMIN');
  get isAdmin(): boolean {
    return this.roleService?.roles?.userType?.includes('ADMIN') || false;
  }
  private _changeProductProperty(key, value) {
    // const data = {
    //   productId: this.list?.id,
    //   name: this.list?.name,
    //   companyName: this.list?.companyName
    // }
    // data[key] = value
    // this.auth
    // .editShopProduct(data)
    // .subscribe({
    //   next: () => {
    //     this.toastr.success('Changed');
    //     this.sharedService.refreshProductId.next({action: 'edited', productId: this.list?.id})
    //   },
    //   error: (err) => {
    //     console.error(err);
    //     this.toastr.error('Error something went wrong while changing');
    //   },
    // });
    this.auth.setProductProperty(this.list?.id, key, value).subscribe({
      next: () => {
        this.toastr.success('Changed');
        this.sharedService.refreshProductId.next({
          action: 'edited',
          productId: this.list?.id,
        });
      },
    });
  }
  public additionalTag = '';

  public sanitizedYoutubeIframes = [];
  @ViewChild('youtubeIframe') youtubeIframeModal: TemplateRef<any>;
  public openYoutubeIframes() {
    const ref = this.modalService.open(YoutubeIframesComponent, { size: 'md' });
    ref.componentInstance.iframes = this.sanitizedYoutubeIframes;
  }
  private _sanitizeYoutubeIframes() {
    this.sanitizedYoutubeIframes = [];
    if (this.list?.additionalTag != 'Youtube') {
      return;
    }
    if (!this.list?.linked?.trim()?.split('\n')) {
      return;
    }
    for (const iframe of this.list?.linked?.trim()?.split('\n')) {
      if (iframe?.trim()?.startsWith('<iframe')) {
        this.sanitizedYoutubeIframes.push(this.sanitizeHTML(iframe));
      }
    }
  }
  public sanitizeHTML(html: string) {
    return this.commonService.sanitizeHTML(html);
  }

  public openEditVerifiedTag() {
    if (!this.isAdmin) {
      return;
    }
    const ref = this.modalService.open(CommonProductChangeTagComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    });
    ref.componentInstance.product = this.list;
    ref.componentInstance.modalClosed.subscribe(() => {
      this.modalService.dismissAll();
    });
  }

  public viewProductDetails(product): void {
    // console.log('whyyyyyyyyyyyyyyyyyyyyyyyyy', this.toSinglePage)
    if (this.toSinglePage) {
      const slug = product.slug;
      this.router.navigate(['/product', slug]);
    } else {
      try {
        if (product.seller_info) {
          product.seller_info = JSON.parse(product.seller_info);
        }
      } catch (e) { }
      // console.log('whyy', product, this.isMemberProduct)
      this.view.next(product);
      //this.viewCount += 1
      if (this.isMemberProduct) {
        this.auth
          .increaseViewCountOfProduct(product.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({ error: console.error });
      }
    }
  }
  getTags(list: any): string[] {
    return (list || '')
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t !== '');
  }
}
